import React, { type FunctionComponent, useEffect } from 'react';
import * as stateManagement from '@/stateManagement';
import * as helpIds from '@/helpIds';
import * as util from '@/util';
import * as coreBi from '@/coreBi';
import { translate } from '@/i18n';
import { bi } from '@/stateManagement';
import FloatingModeBar from '../floatingModeBar/floatingModeBar';
import type { EditorAPI } from '@/editorAPI';

const { openHelpCenter: openHelpCenterAction } = stateManagement.panels.actions;
const { connect, STORES } = util.hoc;
const { popups } = coreBi.events;
const { getPreviewMode } = stateManagement.preview.selectors;
const contexts = util.keyboardShortcuts.CONTEXTS;

interface LightboxModeBarDispatchProps {
  exitMode(): void;
  openHelpCenter(): void;
  getCurrentPreviewMode(): boolean;
}

const LightboxModeBar: FunctionComponent<LightboxModeBarDispatchProps> = (
  props,
) => {
  useEffect(() => {
    util.keyboardShortcuts.setContext(contexts.LIGHTBOX_MODE);
    return () =>
      util.keyboardShortcuts.setContext(
        props.getCurrentPreviewMode() ? contexts.PREVIEW : contexts.EDITOR,
      );
  }, [props]);
  return (
    <FloatingModeBar
      draggableExtentionSlot={
        stateManagement.draggableSlots.DRAGGABLE_SLOTS.LIGHTBOX_MODE_BAR
      }
      title={translate('Topbar_LightboxMode_Label')}
      className="lightbox-mode-bar"
      onExitMode={props.exitMode}
      exitModeLabelKey="Topbar_LightboxMode_Exit_Button"
      onOpenHelpCenter={props.openHelpCenter}
    />
  );
};

const exitMode =
  () =>
  (dispatch: AnyFixMe, getState: AnyFixMe, { editorAPI }: AnyFixMe) => {
    editorAPI.pages.popupPages.close();
    dispatch(
      bi.actions.event(popups.exit_lightbox_mode_click, { origin: 'mode_bar' }),
    );
  };

const openHelpCenter = () => openHelpCenterAction(helpIds.LIGHTBOX.ABOUT);
const getCurrentPreviewMode =
  () =>
  (
    dispatch: AnyFixMe,
    getState: AnyFixMe,
    { editorAPI }: { editorAPI: EditorAPI },
  ) => {
    return getPreviewMode(editorAPI.store.getState());
  };

const mapDispatchToProps = { exitMode, openHelpCenter, getCurrentPreviewMode };

const ConnectedLightboxModeBar = connect(
  STORES.EDITOR_API,
  null,
  mapDispatchToProps,
)(LightboxModeBar);

ConnectedLightboxModeBar.pure = LightboxModeBar;

export default ConnectedLightboxModeBar;
